// extracted by mini-css-extract-plugin
export var content = "_bo-3";
export var list = "_bo-4";
export var settingsContent = "_bo-7";
export var settingsPanel = "_bo-8";
export var state = "_bo-6";
export var triggerBadge = "_bo-2";
export var triggerButton = "_bo-1";
export var triggerShell = "_bo-0";
export var unreadDot = "_bo-5";